export namespace NumberUtil {
  export function compareNumbers(number1: number, number2: number): number {
    if (number1 < number2) {
      return -1;
    } else if (number1 > number2) {
      return 1;
    }
    return 0;
  }

  export function isNumber(num: number): boolean {
    return num != null && !isNaN(num);
  }

  export function round(num: number, decimalPlaces: number): number {
    if (num == null || decimalPlaces == null) {
      return num;
    }

    //http://www.jacklmoore.com/notes/rounding-in-javascript/
    return Number(Math.round(<any>(num + 'e' + decimalPlaces)) + 'e-' + decimalPlaces);
  }

  export function roundToPrecision(value: number, lowDecimals: number, highDecimals: number, useLow: boolean): number {
    return round(value, useLow ? lowDecimals : highDecimals);
  }
}
